import type { InterludeTypes } from "@/interlude";

const DEFAULT_UNIFY_KEYS: Array<InterludeTypes["UnificationKeys"]> = [
  "line_id",
  "fb_id",
  "ig_id",
  "whatsapp_bsuid",
  "display_mobile",
  "display_email",
];

/**
 * Returns the default unification keys when enabling unification.
 *
 * Returns ["line_id", "fb_id", "ig_id", "whatsapp_bsuid", "display_mobile",
 * "display_email"] as the default pre-selected keys. custom_id (Customer ID)
 * is intentionally excluded so customers opt in to it themselves.
 */
export const getDefaultUnifyKeys = (): Array<
  InterludeTypes["UnificationKeys"]
> => {
  return DEFAULT_UNIFY_KEYS;
};
